var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"date-label"},[_c('Date',{attrs:{"date":_vm.getDate,"hover-label":"No date"},on:{"change":_vm.onChange}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }